<template>
  <span class="ctp-direct-account-add">
    <el-button
      class="client-eval-add-btn"
      icon="el-icon-plus"
      type="primary"
      :disabled="disabled"
      @click="openAddDialog"
      >添加</el-button
    >

    <FormDialog
      :visible="showAddDialog"
      :title="dialogTitle"
      :width="860"
      @close="closeAddDialog"
    >
      <el-form
        ref="ctpDirectAddForm"
        :model="addForm"
        :rules="addFormRules"
        label-width="130px"
        size="small"
        label-position="right"
        class="ctp-direct-add-pop__form"
        @submit.native.prevent
      >
        <el-form-item label="经纪商" prop="brokerId">
          <div class="ctp-direct-add-pop__broker">
            <el-select
              ref="brokerSelect"
              v-model="addForm.brokerId"
              placeholder="请选择经纪商"
              clearable
              filterable
              class="ctp-direct-add-pop__control"
              @visible-change="onBrokerSelectVisibleChange"
            >
              <el-option
                v-for="item in brokerSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span class="ctp-direct-broker-option">
                  <span class="ctp-direct-broker-option__name">{{
                    item.label
                  }}</span>
                  <span
                    class="ctp-direct-broker-option__view"
                    @mousedown.stop
                    @click.stop="openBrokerDetail(item)"
                    >查看</span
                  >
                </span>
              </el-option>
            </el-select>
            <a
              class="ctp-direct-add-pop__broker-link"
              href="javascript:;"
              @click.prevent="openConsultBrokerHelp"
              >未找到经纪商?</a
            >
          </div>
        </el-form-item>
        <el-form-item label="APPID" prop="appId">
          <el-input
            v-model="addForm.appId"
            class="ctp-direct-add-pop__control"
            placeholder="请输入APPID"
          />
        </el-form-item>
        <el-form-item label="系统信息" prop="systemInfo">
          <el-input
            v-model="addForm.systemInfo"
            class="ctp-direct-add-pop__control"
            placeholder="请输入系统信息"
          />
        </el-form-item>
        <el-form-item label="授权码" prop="authCode">
          <el-input
            v-model="addForm.authCode"
            class="ctp-direct-add-pop__control"
            placeholder="请输入授权码"
          />
        </el-form-item>
        <el-form-item label="登录账户" prop="userCode">
          <el-input
            v-model="addForm.userCode"
            class="ctp-direct-add-pop__control"
            placeholder="请输入登录账户"
          />
        </el-form-item>
        <el-form-item label="登录姓名" prop="userName">
          <el-input
            v-model="addForm.userName"
            class="ctp-direct-add-pop__control"
            placeholder="请输入登录姓名"
          />
        </el-form-item>
        <el-form-item
          v-if="dialogMode === 'add'"
          label="登录密码"
          prop="userPwd"
        >
          <el-input
            v-model="addForm.userPwd"
            class="ctp-direct-add-pop__control"
            placeholder="请输入登录密码"
            show-password
          />
        </el-form-item>
      </el-form>

      <template slot="footer">
        <el-button
          class="indiv-btn"
          type="primary"
          size="small"
          :loading="submitting"
          @click="onAddSubmitStub"
        >
          提交
        </el-button>
      </template>
    </FormDialog>

    <transition name="el-fade-in-linear">
      <div
        v-show="showConsultBrokerHelp"
        class="ctp-direct-consult-broker-overlay"
        @click.self="closeConsultBrokerHelp"
      >
        <div class="ctp-direct-consult-broker-overlay__panel">
          <ConsultFloatBar :fixed="false" :align-in-right-gutter="false" />
          <span
            class="close iconfont icon-close_round_fill_bold ctp-direct-consult-broker-overlay__close"
            role="button"
            aria-label="关闭"
            @click="closeConsultBrokerHelp"
          ></span>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <div
        v-show="showBrokerDetail"
        class="addr-mask"
        @mousedown.stop
        @click.self="closeBrokerDetail"
      >
        <div class="addr-wrap" @mousedown.stop @click.stop>
          <span
            class="close iconfont icon-close_round_fill_bold addr-close"
            role="button"
            aria-label="关闭"
            @click="closeBrokerDetail"
          ></span>
          <div class="addr-pop">
            <div class="addr-hd">{{ brokerDetailTitle }}</div>
            <div class="addr-bd">
              <el-table
                v-if="brokerDetailRows.length"
                :data="brokerDetailRows"
                border
                size="small"
                :max-height="brokerTableMaxHeight"
                class="addr-table"
                style="width: 100%"
              >
                <el-table-column
                  label="序号"
                  prop="index"
                  width="56"
                  align="center"
                />
                <el-table-column
                  label="交易地址"
                  prop="tradeAddr"
                  min-width="160"
                />
                <el-table-column
                  label="行情地址"
                  prop="quoteAddr"
                  min-width="160"
                />
              </el-table>
              <div v-else class="addr-empty">暂无地址信息</div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <AccountTrialLimitDialog
      :visible.sync="showTrialLimitDialog"
      @purchase="$emit('purchase')"
    />
  </span>
</template>

<script>
import ConsultFloatBar from "@/components/consultFloatBar/index.vue";
import AccountTrialLimitDialog, {
  isTrialAccountLimitError,
} from "../AccountTrialLimitDialog.vue";

/**
 * CTP 直连账户添加/编辑弹窗（userType 固定为 4）
 */

function emptyAddForm() {
  return {
    brokerId: "",
    userCode: "",
    userName: "",
    appId: "",
    systemInfo: "",
    authCode: "",
    userPwd: "",
  };
}

/** 编辑：列表行 + edit_ajax entity 合并为弹窗用的行数据 */
function mergeListRowWithEditAjaxEntity(listRow, entity) {
  if (!entity || typeof entity !== "object") return listRow;

  const out = { ...listRow, ...entity };
  out.userType = listRow.userType;
  out.userTypeName = listRow.userTypeName;

  const id =
    entity.ServerManageId != null && entity.ServerManageId !== ""
      ? entity.ServerManageId
      : entity.serverManageId != null && entity.serverManageId !== ""
      ? entity.serverManageId
      : entity.brokerId != null && entity.brokerId !== ""
      ? entity.brokerId
      : null;
  if (id != null && id !== "") {
    out.ServerManageId = String(id);
    out.brokerId = id;
  }
  const name =
    (entity.serverManageName && String(entity.serverManageName).trim()) ||
    (entity.brokerName && String(entity.brokerName).trim()) ||
    "";
  if (name) {
    out.serverManageName = name;
    out.brokerName = name;
  }

  if (entity.userName != null && String(entity.userName).trim() !== "") {
    out.userName = entity.userName;
  }
  if (entity.userCode != null && String(entity.userCode).trim() !== "") {
    out.userCode = entity.userCode;
  }
  if (entity.appId != null && String(entity.appId).trim() !== "") {
    out.appId = entity.appId;
  }
  if (entity.systemInfo != null && String(entity.systemInfo).trim() !== "") {
    out.systemInfo = entity.systemInfo;
  }
  if (entity.authCode != null && String(entity.authCode).trim() !== "") {
    out.authCode = entity.authCode;
  }
  return out;
}

function splitBrokerAddrSegments(val) {
  if (val == null || val === "") return [];
  return String(val)
    .split("|")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

/** mdAddr=交易地址、tradeAddr=行情地址，按 | 分段对齐为表格行 */
function buildBrokerAddrTableRows(mdAddr, tradeAddr) {
  const tradeList = splitBrokerAddrSegments(mdAddr);
  const quoteList = splitBrokerAddrSegments(tradeAddr);
  const count = Math.max(tradeList.length, quoteList.length);
  const rows = [];
  for (let i = 0; i < count; i++) {
    const tradeAddrVal = tradeList[i] || "";
    const quoteAddrVal = quoteList[i] || "";
    if (!tradeAddrVal && !quoteAddrVal) continue;
    rows.push({
      index: i + 1,
      tradeAddr: tradeAddrVal,
      quoteAddr: quoteAddrVal,
    });
  }
  return rows;
}

/** CTP 经纪商下拉 value 与接口 id（常为 number）对齐 */
function coerceBrokerSelectValue(raw) {
  if (raw === "" || raw == null) return "";
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  const s = String(raw).trim();
  if (s === "") return "";
  const n = Number(s);
  if (Number.isFinite(n) && String(n) === s) return n;
  return raw;
}

// —— 表单校验片段 ——

export default {
  name: "CtpDirectAccountAdd",
  components: { ConsultFloatBar, AccountTrialLimitDialog },
  props: {
    /** status 为 2/3 时由列表传入，禁止添加 */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    addFormRules() {
      return {
        brokerId: [
          { required: true, message: "请选择经纪商", trigger: "change" },
        ],
        userCode: [
          {
            required: true,
            message: "请输入登录账户",
            trigger: "change",
          },
        ],
        appId: [
          {
            required: true,
            message: "请输入APPID",
            trigger: "change",
          },
        ],
        authCode: [
          {
            required: true,
            message: "请输入授权码",
            trigger: "change",
          },
        ],
        userPwd: [
          {
            required: this.dialogMode === "add",
            message: "请输入登录密码",
            trigger: "change",
          },
        ],
      };
    },
    dialogTitle() {
      return this.dialogMode === "edit" ? "编辑CTP直连账户" : "添加CTP直连账户";
    },
    /** 仅当表格总高度超过 400px 时启用 max-height，避免无滚动时出现右侧占位列 */
    brokerTableMaxHeight() {
      const rows = this.brokerDetailRows.length;
      if (!rows) return undefined;
      const headerH = 41;
      const rowH = 41;
      const total = headerH + rows * rowH;
      return total > 400 ? 400 : undefined;
    },
  },
  data() {
    return {
      showAddDialog: false,
      showConsultBrokerHelp: false,
      showBrokerDetail: false,
      brokerDetailTitle: "",
      brokerDetailRows: [],
      dialogMode: "add",
      editingRowId: null,
      submitting: false,
      showTrialLimitDialog: false,
      addForm: emptyAddForm(),
      brokerSelectOptions: [],
    };
  },
  methods: {
    // —— 通用 ——

    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem("token") || "{}");
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    clearAddFormValidate() {
      this.$nextTick(() => {
        const form = this.$refs.ctpDirectAddForm;
        if (form) form.clearValidate();
      });
    },

    fetchBrokerSelectOptions() {
      return this.$axios({
        method: "post",
        url: "/cloud/eval_jees/brokerList",
        params: { apiToken: this.apiToken() },
      }).then((res) => {
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.brokerSelectOptions = list.map((b) => ({
            label: b.name,
            value: b.id,
            mdAddr: b.mdAddr != null ? String(b.mdAddr) : "",
            tradeAddr: b.tradeAddr != null ? String(b.tradeAddr) : "",
          }));
        }
        return this.brokerSelectOptions;
      });
    },
    buildDirectSaveFormBodyString(isEdit) {
      const parts = [];
      const push = (k, v, allowEmpty) => {
        if (v === undefined || v === null) {
          return;
        }
        const s = String(v);
        if (s === "" && !allowEmpty) {
          return;
        }
        parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(s));
      };
      push("apiToken", this.apiToken());
      push("userType", 4);
      push("userCode", String(this.addForm.userCode || "").trim());
      push("userName", String(this.addForm.userName || "").trim(), true);
      push("appId", String(this.addForm.appId || "").trim());
      push("systemInfo", String(this.addForm.systemInfo || "").trim(), true);
      push("authCode", String(this.addForm.authCode || "").trim());
      if (!isEdit) {
        push("userPwd", String(this.addForm.userPwd || "").trim());
      }
      if (isEdit && this.editingRowId != null && this.editingRowId !== "") {
        push("id", this.editingRowId);
      }
      push("brokerId", this.addForm.brokerId);
      return parts.join("&");
    },
    ensureBrokerOption(option) {
      if (!option || option.value == null || option.value === "") {
        return;
      }
      const val = coerceBrokerSelectValue(option.value);
      if (val === "" && val !== 0) {
        return;
      }
      const exists = this.brokerSelectOptions.some(
        (o) => o.value === val || String(o.value) === String(val)
      );
      if (!exists) {
        this.brokerSelectOptions.unshift({
          label: option.label || String(val),
          value: val,
        });
      }
    },
    // —— 弹窗：打开 / 回显 ——

    /** 列表点编辑：拉详情 edit_ajax，填入表单 */
    openForEdit(listRow) {
      if (!listRow) {
        return;
      }
      this.dialogMode = "edit";
      this.fetchBrokerSelectOptions()
        .then(() =>
          this.$axios.post("/cloud/eval_jees/edit_ajax", {
            id: listRow.id,
            apiToken: this.apiToken(),
          })
        )
        .then((res) => {
          this.tokenInvalid(res);
          let row = listRow;
          if (
            res &&
            res.data &&
            res.data.code == 200 &&
            res.data.data &&
            res.data.data.entity
          ) {
            row = mergeListRowWithEditAjaxEntity(listRow, res.data.data.entity);
          }
          this.hydrateEditDialogFromListRow(row);
        })
        .catch(() => {
          this.hydrateEditDialogFromListRow(listRow);
        });
    },
    hydrateEditDialogFromListRow(listRow) {
      this.editingRowId = listRow.id;
      this.ensureBrokerOption({
        label: listRow.serverManageName || listRow.brokerName,
        value: coerceBrokerSelectValue(
          listRow.ServerManageId || listRow.brokerId || ""
        ),
      });

      this.addForm = {
        ...emptyAddForm(),
        brokerId: coerceBrokerSelectValue(
          listRow.ServerManageId || listRow.brokerId || ""
        ),
        userCode: listRow.userCode || "",
        userName: listRow.userName || "",
        appId: listRow.appId != null ? String(listRow.appId) : "",
        systemInfo:
          listRow.systemInfo != null ? String(listRow.systemInfo) : "",
        authCode: listRow.authCode != null ? String(listRow.authCode) : "",
      };
      this.showAddDialog = true;
      this.clearAddFormValidate();
    },

    openAddDialog() {
      if (this.disabled) return;
      this.fetchBrokerSelectOptions();
      this.dialogMode = "add";
      this.editingRowId = null;
      this.addForm = emptyAddForm();
      this.showAddDialog = true;
      this.clearAddFormValidate();
    },

    closeAddDialog() {
      this.showConsultBrokerHelp = false;
      this.closeBrokerDetail();
      this.showAddDialog = false;
      this.dialogMode = "add";
      this.editingRowId = null;
      this.submitting = false;
      this.addForm = emptyAddForm();
      this.clearAddFormValidate();
    },
    openConsultBrokerHelp() {
      this.showConsultBrokerHelp = true;
    },
    closeConsultBrokerHelp() {
      this.showConsultBrokerHelp = false;
    },
    keepBrokerSelectOpen() {
      this.$nextTick(() => {
        const sel = this.$refs.brokerSelect;
        if (!sel) return;
        if (typeof sel.toggleMenu === "function" && !sel.visible) {
          sel.toggleMenu();
        } else if (!sel.visible) {
          sel.visible = true;
        }
      });
    },
    onBrokerSelectVisibleChange(visible) {
      if (!visible && this.showBrokerDetail) {
        this.keepBrokerSelectOpen();
      }
    },
    openBrokerDetail(item) {
      if (!item) return;
      this.brokerDetailTitle = item.label || "经纪商详情";
      this.brokerDetailRows = buildBrokerAddrTableRows(
        item.mdAddr,
        item.tradeAddr
      );
      this.showBrokerDetail = true;
      this.keepBrokerSelectOpen();
    },
    closeBrokerDetail() {
      this.showBrokerDetail = false;
      this.brokerDetailTitle = "";
      this.brokerDetailRows = [];
    },
    onAddSubmitStub() {
      const form = this.$refs.ctpDirectAddForm;
      if (!form || this.submitting) {
        return;
      }
      form.validate((valid) => {
        if (!valid) {
          return;
        }
        const isEdit =
          this.dialogMode === "edit" &&
          this.editingRowId != null &&
          this.editingRowId !== "";
        const url = isEdit
          ? "/cloud/eval_jees/direct_saveEdit"
          : "/cloud/eval_jees/direct_saveNew";
        const body = this.buildDirectSaveFormBodyString(isEdit);
        this.submitting = true;
        this.$axios({
          method: "post",
          url,
          data: body,
          transformRequest: [
            (data) => (typeof data === "string" ? data : data),
          ],
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$emit("saved");
              this.closeAddDialog();
            } else if (isTrialAccountLimitError(res, !isEdit)) {
              this.showTrialLimitDialog = true;
            } else {
              this.$alert(
                (res.data && (res.data.message || res.data.msg)) || "操作失败",
                {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                }
              );
            }
          })
          .catch(() => {
            this.$alert("网络异常，请稍后重试", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.ctp-direct-account-add {
  display: inline-block;
  vertical-align: middle;
}
.ctp-direct-account-add >>> .ctp-direct-add-pop__control {
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
}
.ctp-direct-add-pop__broker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.ctp-direct-add-pop__broker-link {
  color: #5b85ff;
  font-size: 14px;
  text-decoration: none;
  white-space: nowrap;
}
.ctp-direct-add-pop__broker-link:hover {
  text-decoration: underline;
}
.ctp-direct-consult-broker-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 24px;
  background: rgba(0, 0, 0, 0.35);
}
.ctp-direct-consult-broker-overlay__panel {
  position: relative;
  max-width: 100%;
  padding-bottom: 8px;
  transform: translateY(35px);
}
.ctp-direct-consult-broker-overlay__close {
  display: block;
  margin: 20px auto 0;
  font-size: 38px;
  line-height: 1;
  cursor: pointer;
  text-align: center;
}
.ctp-direct-consult-broker-overlay__close.icon-close_round_fill_bold:before {
  background-color: #fff;
  border-radius: 50%;
}
.ctp-direct-broker-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding-right: 8px;
}
.ctp-direct-broker-option__name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ctp-direct-broker-option__view {
  flex-shrink: 0;
  margin-left: 12px;
  color: #5b85ff;
  font-size: 13px;
  cursor: pointer;
}
.ctp-direct-broker-option__view:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}
.addr-mask {
  position: fixed;
  inset: 0;
  z-index: 3500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.35);
}
.addr-wrap {
  position: relative;
  width: 620px;
  max-width: 100%;
}
.addr-pop {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}
.addr-close {
  z-index: 1;
  position: absolute;
  top: -18px;
  right: -18px;
  font-size: 38px;
  line-height: 1;
  cursor: pointer;
}
.addr-close.icon-close_round_fill_bold:before {
  background-color: #fff;
  border-radius: 50%;
}
.addr-hd {
  margin-bottom: 16px;
  padding: 30px 30px 16px;
  border-bottom: 1px solid #f4f4f4;
  font-size: 18px;
  color: #181e2d;
}
.addr-bd {
  padding: 0 30px 30px;
}
.addr-pop >>> .addr-table {
  font-size: 14px;
  color: #181e2d;
}
.addr-pop >>> .addr-table .cell {
  word-break: break-all;
  line-height: 1.5;
}
.addr-empty {
  padding: 8px 0;
  font-size: 14px;
  color: #909399;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/ctp_direct/CtpDirectAccountAdd.vue